module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Dados da Pessoa")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_vm._m(0), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.pessoa.nome_razao))])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_vm._m(1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.pessoa.cpf_cnpj))])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_vm._m(2), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.pessoa.telefone1 ? _vm.pessoa.telefone1 : '') + "\n          " + _vm._s(_vm.pessoa.telefone2 ? ' | ' + _vm.pessoa.telefone2 : '') + "\n          " + _vm._s(_vm.pessoa.tel_ref_comercial ? ' | ' + _vm.pessoa.tel_ref_comercial : '') + "\n          " + _vm._s(_vm.pessoa.tel_ref_pessoal ? ' | ' + _vm.pessoa.tel_ref_pessoal : '') + "\n        ")])])])]), _vm._v(" "), _c('h4', {
    staticClass: "mt-40"
  }, [_vm._v("Novo Agendamento")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-lg-9"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('descricao')
    }
  }, [_c('label', {
    attrs: {
      "for": "descricao"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.novoAgendamento.descricao),
      expression: "novoAgendamento.descricao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "descricao"
    },
    domProps: {
      "value": (_vm.novoAgendamento.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.novoAgendamento, "descricao", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('descricao')),
      expression: "errors.has('descricao')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Campo obrigatório")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-lg-3"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('data')
    }
  }, [_c('label', {
    attrs: {
      "for": "data"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.novoAgendamento.data),
      expression: "novoAgendamento.data"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data",
      "type": "date"
    },
    domProps: {
      "value": (_vm.novoAgendamento.data)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.novoAgendamento, "data", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('data')),
      expression: "errors.has('data')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Campo obrigatório")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right mt-20"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.criarAgendamento()
      }
    }
  }, [_vm._v("Agendar")])]), _vm._v(" "), _c('h4', {
    staticClass: "mt-40"
  }, [_vm._v("Agendamentos registrados para esta pessoa")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.apiData.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "odd",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.descricao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.status))]), _vm._v(" "), _c('td', [_vm._v("\n              Registrado em:\n              "), _c('b', [_vm._v(_vm._s(_vm._f("dataHoraFormatada")(item.created_at)))]), _vm._v(" por\n              "), _c('b', [_vm._v(_vm._s(item.usuario.name))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.apiData.from) + " até " + _vm._s(this.apiData.to) + " de " + _vm._s(this.apiData.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.apiData
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Nome/Razão:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Cpf/Cnpj:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Telefones:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Log")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-100418ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cobranca/inadimplentes/inadimplenteAgendamento.vue
// module id = 384
// module chunks = 1